"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Departure-specific API calls
var DepartureService = exports.DepartureService = function () {
    function DepartureService(winresCloudService, $filter) {
        _classCallCheck(this, DepartureService);

        this.winresCloudService = winresCloudService;
        this.$filter = $filter;
    }

    _createClass(DepartureService, [{
        key: "getDeparturesByDestinationCodeAndDepartureDateRange",
        value: function getDeparturesByDestinationCodeAndDepartureDateRange(destinationCode, begindate, enddate, cancelService) {
            return this.winresCloudService.makeAuthenticatedRequest('GetDeparturesByDestinationCodeAndDepartureDateRange', {
                "DestinationCode": destinationCode,
                "BeginDate": begindate,
                "EndDate": enddate
            });
        }
    }, {
        key: "searchDepartures",
        value: function searchDepartures(searchCriteria) {
            return this.winresCloudService.makeAuthenticatedRequest('SearchDepartures', {
                SearchCriteria: searchCriteria
            });
        }
    }, {
        key: "checkDeparture",
        value: function checkDeparture(destCode, beginDate, endDate, stopID) {
            var possibleInvalidResult = null;
            return this.searchDepartures({
                'Language': this.winresCloudService.getLanguage(),
                'BeginDate': beginDate,
                'EndDate': endDate,
                'DestCodes': [destCode],
                'NumAdults': 1,
                'NumChildren': 0,
                'NumInfants': 0,
                'IgnoreEverything': true,
                'StopID': stopID
            }).then(function (result) {
                var _console;

                if (result === null || result === undefined) {
                    // This should only happen if the request was canceled.
                    return null;
                }

                if (!result || !result.Results) {
                    possibleInvalidResult = result;
                    throw new Error('Invalid result.');
                }

                var dep = result.Results[0];

                if (!dep) {
                    // throw new Error('Departure not found.');
                    // The departure does not seem to exist. Either it has been removed,
                    // or it was somehow filtered out.
                    // Consider it unavailable.
                    return false;
                }

                // Get blockers
                var blockers = _.toArray(dep.Blockers);

                (_console = console).log.apply(_console, ['[DepartureService] Departure blockers:'].concat(_toConsumableArray(blockers)));

                // Ignore closed departures - those are available with a direct link.
                _.pull(blockers, 'DestinationClosed');

                return blockers;
            }).catch(function (error) {
                // Default to available since this is a new check and may fail for
                // some unexpected reason.
                console.error('[DepartureService] Departure availability check failed. Falling back to available. Error:', error);
                if (possibleInvalidResult !== null) {
                    console.log('[DepartureService] The invalid result was:', possibleInvalidResult);
                }
                return [];
            });
        }
    }, {
        key: "searchDayCapacity",
        value: function searchDayCapacity(searchCriteria) {
            return this.winresCloudService.makeAuthenticatedRequestWithResponse('SearchDayCapacity', {
                SearchCriteria: searchCriteria
            });
        }
    }, {
        key: "searchActivities",
        value: function searchActivities(searchCriteria) {
            return this.winresCloudService.makeAuthenticatedRequestWithResponse('SearchActivities', {
                SearchCriteria: searchCriteria
            });
        }
    }, {
        key: "searchPackages",
        value: function searchPackages(searchCriteria) {
            return this.winresCloudService.makeAuthenticatedRequestWithResponse('SearchPackages', {
                SearchCriteria: searchCriteria
            });
        }

        // Backwards compatibility method. Use searchDepartures in new code.

    }, {
        key: "searchReservableItemsWithSearchDepartures",
        value: function searchReservableItemsWithSearchDepartures(searchCriteria, withReserveLink, language) {

            // There are two ways to search by date range:
            // Either the entire trip must fit within the date range, or the
            // begin date must fit within the date range.
            // The second option is used by e.g. calendars that show all trips
            // that begin within the specified month.
            // The old SearchReservableItems supported this with a MatchStartDate
            // flag that changes the meaning of EndDate.
            // The new SearchDepartures supports this with a separate BeginBeforeDate
            // field. Note that BeginBeforeDate is the date _after_ the end of the
            // period, so one day needs to be added to EndDate during the conversion.
            var matchStartDate = searchCriteria.MatchStartDate || _.includes(searchCriteria.Flags, 'MatchStartDate');

            var beginBeforeDate = matchStartDate ? moment(searchCriteria.EndDate).add(1, 'days').format('Y-MM-DD') : null;

            var endDate = matchStartDate ? null : searchCriteria.EndDate;

            var compatibleCriteria = {
                'Language': language,
                'Offset': searchCriteria.Offset,
                'Limit': searchCriteria.Limit,
                'BeginDate': searchCriteria.StartDate,
                'BeginBeforeDate': beginBeforeDate,
                'EndDate': endDate,
                'DestCodes': searchCriteria.DestinationCodes,
                'DestClasses1': searchCriteria.Classifications1,
                'DestClasses2': searchCriteria.Classifications2,
                'DestClasses3': searchCriteria.Classifications3,
                'DestClasses4': searchCriteria.Classifications4,
                'DestClasses5': searchCriteria.Classifications5,
                'IsOffer': searchCriteria.IsOffer,
                'LengthInDaysMin': searchCriteria.LengthInDaysMinimum,
                'LengthInDaysMax': searchCriteria.LengthInDaysMaximum,
                'PriceMin': searchCriteria.PriceMinimum,
                'PriceMax': searchCriteria.PriceMaximum,
                'FreePlacesMin': searchCriteria.FreePlacesMin,
                'FreePlacesMax': searchCriteria.FreePlacesMax,
                'PriceGroup': searchCriteria.PriceGroup,
                'NumAdults': searchCriteria.NumAdults,
                'NumChildren': searchCriteria.NumChildren,
                'NumInfants': searchCriteria.NumInfants,
                'ChildAges': searchCriteria.ChildAges,
                'NumRooms': searchCriteria.NumRooms,
                'ResultsPerDest': searchCriteria.EarliestNDeparturesPerDestination || searchCriteria.ResultsPerDest,
                'IgnoreCapacity': searchCriteria.IgnoreCapacity,
                'IgnoreClosingDate': searchCriteria.IgnoreClosingDate,
                'StopID': searchCriteria.StopID,
                'LinkType': searchCriteria.LinkType,
                'IgnoreEverything': searchCriteria.IgnoreEverything
            };

            return this.searchDepartures(compatibleCriteria).then(function (data) {
                // Request may have been canceled.
                if (!data) return null;

                // Compatibility with SearchReservableItems results.
                // NOTE: This does not include all fields that SearchReservableItems returns!
                // Only use this function if you've checked that other fields are not required.
                // If some other field can be derived from SearchDepartures results, it can
                // of course be added here.
                // Some data shows up in multiple places, such as the destination code.

                // This must be exact because some templates do string comparisons
                // to datetimes returned by other Cloud queries!
                var wrcDateTimeFormat = 'Y-MM-DDTHH:mm:ss.SSSSSSS';

                var nextOffset = data.Offset + data.Results.length;

                return {
                    Total: data.Total,
                    HasMore: nextOffset < data.Total,
                    HasSeoLinks: data.HasSeoLinks,
                    Results: _.map(data.Results, function (r) {
                        var startDateTime = moment(r.StartDate).format(wrcDateTimeFormat);
                        var endDateTime = moment(r.EndDate).format(wrcDateTimeFormat);

                        return {
                            StartDate: startDateTime,
                            EndDate: endDateTime,
                            Destination: {
                                DestinationCode: r.DestinationCode,
                                DestinationName: r.DestinationName,
                                Headline: '',
                                DescriptionOfDestination: '',
                                Images: r.Images
                            },
                            IsOffer: r.IsOffer,
                            IsPreview: _.includes(r.Blockers, 'Preview'),
                            Capacity: {
                                Available: r.FreePlaces,
                                IsEnough: r.FreePlaces > 0,
                                AvailableMR: r.FreePlacesMR,
                                AvailableMS: r.FreePlacesMS,
                                HasFreeMRPlaces: r.HasFreeMRPlaces,
                                HasFreeMSPlaces: r.HasFreeMSPlaces
                            },
                            Departure: {
                                DestinationCode: r.DestinationCode,
                                PriceFrom2hh: r.Pricing.Price,
                                DepartureDate: startDateTime,
                                ArrivalDate2: endDateTime
                            },
                            PriceDescription: r.Pricing.Label,
                            Price: r.Pricing.Price,
                            IsReservableWithCurrentCriteria: r.Reservable,
                            ReservationLink: withReserveLink ? r.ReserveLink : undefined,
                            AdditionalDescriptionLink: r.AdditionalDescriptionLink
                        };
                    })
                };
            });
        }

        // For finding out which fields are actually used

    }, {
        key: "searchReservableItemsProxy",
        value: function searchReservableItemsProxy(searchCriteria, withReserveLink, language) {
            return this.searchReservableItems(searchCriteria, withReserveLink, language).then(function (response) {
                return makeProxy(5, '', response);
            });
        }

        // Backwards compatibility method. Use searchDepartures in new code.

    }, {
        key: "searchReservableItemsWithSearchDayCapacity",
        value: function searchReservableItemsWithSearchDayCapacity(searchCriteria, withReserveLink, language) {
            if (_.includes(searchCriteria.Classifications1, 'AK')) {
                return this.searchReservableItemsWithSearchActivities(searchCriteria, withReserveLink, language);
            }

            var compatibleCriteria = {
                'Language': language,
                'Offset': searchCriteria.Offset,
                'Limit': searchCriteria.Limit,
                'Sort': searchCriteria.Sort,
                'BeginDate': searchCriteria.StartDate,
                'EndDate': searchCriteria.EndDate,
                'DestClasses1': searchCriteria.Classifications1,
                'DestClasses2': searchCriteria.Classifications2,
                'DestClasses3': searchCriteria.Classifications3,
                'DestClasses4': searchCriteria.Classifications4,
                'DestClasses5': searchCriteria.Classifications5,
                'DestRegions': searchCriteria.Regions,
                'NumAdults': searchCriteria.NumAdults,
                'NumChildren': searchCriteria.NumChildren,
                'NumInfants': searchCriteria.NumInfants,
                'ChildAges': searchCriteria.ChildAges,
                'NumRooms': searchCriteria.NumRooms,
                'IncludeCriteriaValues': _.includes(searchCriteria.Flags, 'GetCriteriaValues'),
                'IgnoreCapacity': searchCriteria.IgnoreCapacity,
                'IgnoreMissingPrice': searchCriteria.IgnoreMissingPrice,
                'DestProducers': searchCriteria.Producers,
                'ProdPriceCategories': searchCriteria.PriceCategories,
                'DiscountCode': searchCriteria.DiscountCode,
                'IgnoreEverything': searchCriteria.IgnoreEverything
            };

            return this.searchDayCapacity(compatibleCriteria).then(function (data) {
                // Request may have been canceled.
                if (!data) return null;

                // Compatibility with SearchReservableItems results.
                // NOTE: This does not include all fields that SearchReservableItems returns!
                // Only use this function if you've checked that other fields are not required.
                // If some other field can be derived from SearchDayCapacity results, it can
                // of course be added here.

                // This must be exact because some templates do string comparisons
                // to datetimes returned by other Cloud queries!
                var wrcDateTimeFormat = 'Y-MM-DDTHH:mm:ss.SSSSSSS';

                // The dates will of course be the same for all of these.
                var startDateTime = moment(searchCriteria.StartDate).format(wrcDateTimeFormat);
                var endDateTime = moment(searchCriteria.EndDate).format(wrcDateTimeFormat);

                var nextOffset = data.Offset + data.Results.length;

                return {
                    Total: data.Total,
                    HasMore: nextOffset < data.Total,
                    Results: _.map(data.Results, function (r) {
                        return {
                            StartDate: startDateTime,
                            EndDate: endDateTime,
                            // Description: '', // Not actually used?
                            IsOffer: r.Price.IsOffer,
                            Price: r.Price.Price,
                            OriginalPrice: r.Price.Original,
                            IsDiscount: r.Price.IsDiscount,
                            Rating: r.Dest.Rating,
                            CriteriaValues: r.Prod.CriteriaValues,
                            ReservationLink: withReserveLink ? r.Link : undefined,
                            DisplayName: r.DisplayName, // May be null

                            Destination: {
                                DestinationCode: r.DestCode,
                                DestinationName: r.Dest.ExtraName || r.Dest.Name, // Use ExtraName if not null or empty
                                DescriptionOfDestination: r.Dest.Description,
                                Headline: r.Dest.Headline,
                                SubGroup: r.Dest.SubGroup,
                                Images: [r.Dest.Image]
                            },

                            Product: {
                                DestinationInfo: {
                                    ProductCode: r.ProdCode,
                                    ProductName: r.Prod.ExtraName || r.Prod.Name, // Use ExtraName if not null or empty
                                    ProductType: r.Prod.Type,
                                    Beds: r.Prod.Beds,
                                    ExtraBeds: r.Prod.ExtraBeds
                                },

                                ForceReservedDays: null, // Is this required for anything here?
                                PriceNote: r.Price.Note,
                                IsReservableWithCurrentCriteria: r.Reservable,

                                ReservabilityCheckResults: {
                                    CapacityIsEnough: r.FreePlaces > 0,
                                    Price: r.Price.Price > 0
                                },

                                ReservablePrices: r.ReservablePrices, // Activity price selection.

                                UsesTimeSlots: r.Prod.UsesTimeSlots
                            },

                            // External day capacity products don't return price yet,
                            // use this to show check price -text.
                            // 2024-11-15: They do now if the BB supports it.
                            ExternalSystem: r.ExternalSystem
                        };
                    })
                };
            });
        }
    }, {
        key: "searchReservableItemsWithSearchActivities",
        value: function searchReservableItemsWithSearchActivities(searchCriteria, withReserveLink, language) {
            var compatibleCriteria = {
                'Language': language,
                'Offset': searchCriteria.Offset,
                'Limit': searchCriteria.Limit,
                'Sort': ['DateTime'].concat(searchCriteria.Sort || []),
                'SearchBeginDate': searchCriteria.StartDate,
                'SearchEndDate': searchCriteria.EndDate,
                'DestClasses1': searchCriteria.Classifications1,
                'DestClasses2': searchCriteria.Classifications2,
                'DestClasses3': searchCriteria.Classifications3,
                'DestClasses4': searchCriteria.Classifications4,
                'DestClasses5': searchCriteria.Classifications5,
                'DestRegions': searchCriteria.Regions,
                'NumAdults': searchCriteria.NumAdults,
                'NumChildren': searchCriteria.NumChildren,
                // 'NumInfants': searchCriteria.NumInfants,
                // 'ChildAges': searchCriteria.ChildAges,
                // 'NumRooms': searchCriteria.NumRooms,
                'IncludeCriteriaValues': _.includes(searchCriteria.Flags, 'GetCriteriaValues'),
                'IgnoreCapacity': searchCriteria.IgnoreCapacity,
                'IgnoreMissingPrice': searchCriteria.IgnoreMissingPrice,
                'DestProducers': searchCriteria.Producers,
                'ProdPriceCategories': searchCriteria.PriceCategories,
                'DiscountCode': searchCriteria.DiscountCode
                // 'IgnoreEverything': searchCriteria.IgnoreEverything,
            };

            return this.searchActivities(compatibleCriteria).then(function (data) {
                // Request may have been canceled.
                if (!data) return null;

                // Compatibility with SearchReservableItems results.
                // NOTE: This does not include all fields that SearchReservableItems returns!
                // Only use this function if you've checked that other fields are not required.
                // If some other field can be derived from SearchActivities results, it can
                // of course be added here.

                // This must be exact because some templates do string comparisons
                // to datetimes returned by other Cloud queries!
                var wrcDateTimeFormat = 'Y-MM-DDTHH:mm:ss.SSSSSSS';

                var nextOffset = data.Offset + data.Results.length;

                return {
                    Total: data.Total,
                    HasMore: nextOffset < data.Total,
                    Results: _.map(data.Results, function (r) {
                        return {
                            IsActivity: true,
                            StartDate: moment(r.BeginDate).format(wrcDateTimeFormat),
                            EndDate: moment(r.EndDate).add(1, 'days').format(wrcDateTimeFormat),
                            // Description: '', // Not actually used?
                            IsOffer: r.Price.IsOffer,
                            Price: r.Price.Price,
                            OriginalPrice: r.Price.Original,
                            IsDiscount: r.Price.IsDiscount,
                            Rating: r.Dest.Rating,
                            CriteriaValues: r.Prod.CriteriaValues,
                            ReservationLink: withReserveLink ? r.Link : undefined,

                            Destination: {
                                DestinationCode: r.DestCode,
                                DestinationName: r.Dest.ExtraName || r.Dest.Name, // Use ExtraName if not null or empty
                                DescriptionOfDestination: r.Dest.Description,
                                Headline: r.Dest.Headline,
                                SubGroup: r.Dest.SubGroup,
                                Images: [r.Dest.Image]
                            },

                            Product: {
                                DestinationInfo: {
                                    ProductCode: r.ProdCode,
                                    ProductName: r.Prod.ExtraName || r.Prod.Name, // Use ExtraName if not null or empty
                                    ProductType: r.Prod.Type,
                                    Beds: r.Prod.Beds,
                                    ExtraBeds: r.Prod.ExtraBeds
                                },

                                ForceReservedDays: null, // Is this required for anything here?
                                PriceNote: r.Price.Note,
                                IsReservableWithCurrentCriteria: r.Reservable,

                                ReservabilityCheckResults: {
                                    CapacityIsEnough: r.FreePlaces > 0,
                                    Price: r.Price.Price > 0
                                },

                                ReservablePrices: r.ReservablePrices, // Activity price selection.

                                UsesTimeSlots: r.Prod.UsesTimeSlots
                            },

                            ExternalSystem: r.ExternalSystem
                        };
                    })
                };
            });
        }
    }, {
        key: "searchReservableItemsWithSearchPackages",
        value: function searchReservableItemsWithSearchPackages(searchCriteria, withReserveLink, language) {
            var compatibleCriteria = {
                'Language': language,
                'Offset': searchCriteria.Offset,
                'Limit': searchCriteria.Limit,
                'Sort': ['DateTime'].concat(searchCriteria.Sort || []),
                'SearchBeginDate': searchCriteria.StartDate,
                'SearchEndDate': searchCriteria.EndDate,
                'DestClasses1': searchCriteria.Classifications1,
                'DestClasses2': searchCriteria.Classifications2,
                'DestClasses3': searchCriteria.Classifications3,
                'DestClasses4': searchCriteria.Classifications4,
                'DestClasses5': searchCriteria.Classifications5,
                'DestRegions': searchCriteria.Regions,
                'NumAdults': searchCriteria.NumAdults,
                'NumChildren': searchCriteria.NumChildren,
                // 'NumInfants': searchCriteria.NumInfants,
                // 'ChildAges': searchCriteria.ChildAges,
                // 'NumRooms': searchCriteria.NumRooms,
                'IncludeCriteriaValues': _.includes(searchCriteria.Flags, 'GetCriteriaValues'),
                'IgnoreCapacity': searchCriteria.IgnoreCapacity,
                'IgnoreMissingPrice': searchCriteria.IgnoreMissingPrice,
                'DestProducers': searchCriteria.Producers,
                'ProdPriceCategories': searchCriteria.PriceCategories,
                'DiscountCode': searchCriteria.DiscountCode
                // 'IgnoreEverything': searchCriteria.IgnoreEverything,
            };

            return this.searchPackages(compatibleCriteria).then(function (data) {
                // Request may have been canceled.
                if (!data) return null;

                // Compatibility with SearchReservableItems results.
                // NOTE: This does not include all fields that SearchReservableItems returns!
                // Only use this function if you've checked that other fields are not required.
                // If some other field can be derived from SearchDayCapacity results, it can
                // of course be added here.

                // This must be exact because some templates do string comparisons
                // to datetimes returned by other Cloud queries!
                var wrcDateTimeFormat = 'Y-MM-DDTHH:mm:ss.SSSSSSS';

                var nextOffset = data.Offset + data.Results.length;

                return {
                    Total: data.Total,
                    HasMore: nextOffset < data.Total,
                    Results: _.map(data.Results, function (r) {
                        return {
                            IsPackage: true,
                            StartDate: moment(r.BeginDate).format(wrcDateTimeFormat),
                            EndDate: moment(r.EndDate).format(wrcDateTimeFormat),
                            // Description: '', // Not actually used?
                            IsOffer: r.Price.IsOffer,
                            Price: r.Price.Price,
                            OriginalPrice: r.Price.Original,
                            IsDiscount: r.Price.IsDiscount,
                            Rating: r.Dest.Rating,
                            CriteriaValues: r.Prod.CriteriaValues,
                            ReservationLink: withReserveLink ? r.Link : undefined,

                            Destination: {
                                DestinationCode: r.DestCode,
                                DestinationName: r.Dest.ExtraName || r.Dest.Name, // Use ExtraName if not null or empty
                                DescriptionOfDestination: r.Dest.Description,
                                Headline: r.Dest.Headline,
                                SubGroup: r.Dest.SubGroup,
                                Images: [r.Dest.Image]
                            },

                            Product: {
                                DestinationInfo: {
                                    ProductCode: r.ProdCode,
                                    ProductName: r.Prod.ExtraName || r.Prod.Name, // Use ExtraName if not null or empty
                                    ProductType: r.Prod.Type,
                                    Beds: r.Prod.Beds,
                                    ExtraBeds: r.Prod.ExtraBeds
                                },

                                ForceReservedDays: null, // Is this required for anything here?
                                PriceNote: r.Price.Note,
                                IsReservableWithCurrentCriteria: r.Reservable,

                                ReservabilityCheckResults: {
                                    CapacityIsEnough: r.FreePlaces > 0,
                                    Price: r.Price.Price > 0
                                },

                                ReservablePrices: r.ReservablePrices, // Activity price selection.

                                UsesTimeSlots: r.Prod.UsesTimeSlots
                            },

                            // External day capacity products don't return price yet,
                            // use this to show check price -text.
                            ExternalSystem: r.ExternalSystem
                        };
                    })
                };
            });
        }
    }, {
        key: "searchReservableItems",
        value: function searchReservableItems(searchCriteria, withReserveLink, language) {
            return this.winresCloudService.makeAuthenticatedRequest('SearchReservableItems', {
                'Language': language,
                'WithReserveLink': withReserveLink,
                'SearchCriteria': searchCriteria
            });
        }
    }, {
        key: "getDeparturesInfo",
        value: function getDeparturesInfo(destCodes, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetDeparturesInfo', {
                'DestCodes': destCodes,
                'Language': language
            });
        }
    }, {
        key: "getExtraQuestions",
        value: function getExtraQuestions(products, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetExtraQuestions', {
                'Products': products,
                'Language': language
            });
        }
    }, {
        key: "getWinresDeparture",
        value: function getWinresDeparture(destinationCode, departureDate, arrivalDate, language, getCapacityAvailable) {
            return this.winresCloudService.makeAuthenticatedRequest('GetWinresDeparture', {
                'DestinationCode': destinationCode,
                'DepartureDate': departureDate,
                'ArrivalDate': arrivalDate,
                'Language': language,
                'GetCapacityAvailable': getCapacityAvailable
            });
        }
    }, {
        key: "getDepartureAccommodations",
        value: function getDepartureAccommodations(destCode, beginDate, endDate, stopID) {
            return this.winresCloudService.makeAuthenticatedRequest('GetDepartureAccommodations', {
                DestCode: destCode,
                BeginDate: beginDate,
                EndDate: endDate,
                StopID: stopID,
                Language: this.winresCloudService.getLanguage()
            });
        }

        // Dummy

    }, {
        key: "searchDayCapacityWithDiscountCode",
        value: function searchDayCapacityWithDiscountCode(searchCriteria, withReserveLink, language) {
            var _this = this;

            return this.searchReservableItemsWithSearchDayCapacity(searchCriteria, withReserveLink, language).then(function (response) {
                return _this.getDiscountResults(searchCriteria, response.Results);
            });
        }

        // Dummy

    }, {
        key: "isValidDiscountCode",
        value: function isValidDiscountCode(destCode, discountCode) {
            // Hardcoded discount codes
            // WINRES_JOIKU2
            var table = [{ DestCode: 'MK8VUO', DiscountCode: 'ABCD' }, { DestCode: 'PK6VUOB', DiscountCode: 'XXXX' }];

            // Check is destCode and discountCode match
            return _.some(table, function (t) {
                return destCode === t.DestCode && discountCode === t.DiscountCode;
            });
        }

        // Dummy
        //
        // New fields SearchDayCapacity should return
        // {
        //     IsDiscount
        //     OriginalPrice
        //     ~PriceAfterDiscount~
        //     DiscountPrice (optional)
        // }

    }, {
        key: "getDiscountResults",
        value: function getDiscountResults(searchCriteria, results) {
            var _this2 = this;

            var resultsWithDiscountCode = _.filter(results, function (result) {
                return _this2.isValidDiscountCode(result.Destination.DestinationCode, searchCriteria.DiscountCode);
            });

            _.each(resultsWithDiscountCode, function (result) {
                result.IsDiscount = true;

                // Original price
                result.OriginalPrice = result.Price;

                // Price after discount
                result.Price = 123;

                // Discount product price
                result.DiscountPrice = -(result.OriginalPrice - result.Price);
            });

            return {
                "Offset": 0,
                "Results": resultsWithDiscountCode
            };
        }
    }]);

    return DepartureService;
}();

function handler(path) {
    return {
        get: function get(obj, prop) {
            var value = obj[prop];
            if (!_.isObject(value)) {
                console.log('[ACCESS]', path, prop);
            }
            return value;
        },

        set: function set(obj, prop, value) {
            console.log('[SET]', path, prop);
            obj[prop] = value;
            return true;
        }
    };
};

function makeProxy(depth, path, target) {
    if (depth <= 0) {
        return target;
    }
    if (_.isArray(target)) {
        return new Proxy(_.map(target, function (value, i) {
            return makeProxy(depth - 1, path + ' ' + i, value);
        }), handler(path));
    } else if (_.isObject(target)) {
        return new Proxy(_.mapValues(target, function (value, key) {
            return makeProxy(depth - 1, path + ' ' + key, value);
        }), handler(path));
    } else {
        return target;
    }
}

DepartureService.$inject = ['winresCloudService', '$filter'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/departureService.js
// module id = 565
// module chunks = 2